import pic001 from '../../assets/images/works/ai/ai-1.webp'
import pic002 from '../../assets/images/works/ai/ai-2.webp'
import pic003 from '../../assets/images/works/ai/ai-3.webp'
import pic004 from '../../assets/images/works/ai/ai-4.webp'

import avatar from '../../assets/images/authors/ai.webp'

const data = [
  {
    id: 1,
    avatar: avatar,
    link: 'https://openai.com/dall-e-3',
    name: 'AI',
    title: 'Crypto Connect',
    pic: pic001
  },
  {
    id: 2,
    avatar: avatar,
    link: 'https://openai.com/dall-e-3',
    name: 'AI',
    title: 'Abstract Tablet Holder',
    pic: pic002
  },
  {
    id: 3,
    avatar: avatar,
    link: 'https://openai.com/dall-e-3',
    name: 'AI',
    title: 'Vivid Swirls in Water',
    pic: pic003
  },
  {
    id: 4,
    avatar: avatar,
    link: 'https://openai.com/dall-e-3',
    name: 'AI',
    title: 'Paper Mountainscape',
    pic: pic004
  }
]

export default data
